import React from 'react';
import { Radio, FormControlLabel } from '@mui/material';
import { RadioButtonProps } from './RadioButton.props';

export const CustomRadioButton: React.FC<RadioButtonProps> = ({
  size = 'm',
  color = 'primary',
  label,
  sx,
  ...radioProps
}) => {
  const radioComponent = (
    <Radio {...radioProps} size={size} color={color} sx={sx} />
  );

  if (label) {
    return <FormControlLabel control={radioComponent} label={label} />;
  }

  return radioComponent;
};
